import { combineReducers } from "redux";
import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/wrapperReducer";
import TransactionHistory from "./TransactionHistory";
export default combineReducers({
    transactionHistory: createNamedWrapperReducer(TransactionHistory, "TransactionHistory"),
});
